import { render, staticRenderFns } from "./dd-loading.vue?vue&type=template&id=9c53acac&scoped=true&"
import script from "./dd-loading.vue?vue&type=script&lang=ts&"
export * from "./dd-loading.vue?vue&type=script&lang=ts&"
import style0 from "./dd-loading.vue?vue&type=style&index=0&id=9c53acac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c53acac",
  null
  
)

export default component.exports